import { Roles } from '@pwp-common';

export const getUserHomepage = (userRoles: Roles): string =>
  userRoles.isOrgAdmin() ? '/modify-schedule' : '/events-calendar';
